module.exports = __webpack_public_path__ + "media/welcomeBack.0db98cad.mp3";